import { render, staticRenderFns } from "./CommonMenu.vue?vue&type=template&id=409dbd65&scoped=true&"
import script from "./CommonMenu.vue?vue&type=script&lang=js&"
export * from "./CommonMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409dbd65",
  null
  
)

export default component.exports